import React from 'react';

class Stub extends React.Component {
    render() {
        alert('catalog');
        return (
            <div></div>
        )
    }
}

export default Stub;